<template>
  <div v-if="filesLength" class="col-md-3 col-sm-4 text-center" style="height:250px;">
    <input type="file" accept="image/*" @change="handleUpload" id="upload" style="visibility:hidden" multiple>
     <!-- Drop Zone -->
    <button class="btn btn-default upload-drop-zone"
            onclick="document.getElementById('upload').click();" id="drop-zone">
      <span class="glyphicon glyphicon-plus" aria-hidden="true"></span><br>
      Voeg Foto's toe (max 5) 
      <p>Uploaden
      <i v-show="showspinner" class="fa fa-spinner fa-pulse"></i>
      </p>
    </button>
  </div>
  <div v-sortable="options" class="sortable grid">
  <div class="col-md-3 col-sm-4 text-center image-move" style="border-style: groove;position: relative; height:250px;"
   v-for="item in files" track-by="$index">
    <img class="img-responsive" :src="item.URL" style="height:240px">
    <button class="btn btn-default btn-circle fa fa-times" 
    style="color:red; position:absolute; top:5px;right:5px;" @click="removeFile($index)"></button>      
  </div>
  </div>
  <!--
    <table class="table table-hover">
      <tbody>
        <tr v-for="item in files" track-by="$index">
          <td><a :href="item.URL" target="_blank"> {{item.FileName}} </a> </td>
          <td>{{item.Size}}</td>
          <td class="text-center">
          <a class="fa fa-times" style="color:red;" @click="removeFile($index)"></a>
          </td>
        </tr>
      </tbody>       
    </table>  -->
</template>

<script>
import store from '../../store'
export default {
  props: {
    url: { type: String, default: 'api/products/uploadphoto' },
    files: { type: Array, twoWay: true }
  },
  data () {
    return {
      store: store,
      showspinner: false,
      options: {
        handle: '.image-move',
        animation: 100,
        scrollSensitivity: 10,
        scrollSpeed: 10,
        onUpdate: function (evt) {
          this.el._vue_directives[0].vm._sort(evt.oldIndex, evt.newIndex)
        }
      }
    }
  },
  methods: {
    _sort: function (oldindex, newindex) {
      var content = this.files[oldindex]
      this.files.splice(oldindex, 1)
      this.files.splice(newindex, 0, content)
      this.orderArray()
    },
    orderArray: function () {
      for (var i = 0; i < this.files.length; i++) {
        this.files[i].Order = i
      }
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (files.length > 0) {
        for (var i = 0; i < files.length; i++) {
          this.createFile(files[i])
        }
      }
    },
    createFile (file, index) {
      // var reader = new FileReader()
      // reader.onload = (e) => {
      //   var fileObject = {}
      //   fileObject.id = index
      //   fileObject.name = file.name
      //   fileObject.size = file.size
      //   fileObject.src = e.target.result
      //   this.files.push(fileObject)
      // }
      // reader.readAsDataURL(file)
    },
    handleUpload: function (e) {
      // console.log(this)
      var formData = new FormData()
      var totalFiles = document.getElementById('upload').files.length
      if (totalFiles > 0) {
        for (var i = 0; i < totalFiles; i++) {
          this.showspinner = true
          var file = document.getElementById('upload').files[i]
          formData.append('upload' + i, file)
        }
        $.ajax({
          type: 'POST',
          url: store.root + this.url,
          data: formData,
          dataType: 'json',
          contentType: false,
          processData: false,
          xhrFields: {
            withCredentials: true
          },
          success: function (response) {
            for (var i = 0; i < response.length; i++) {
              this.files.push(response[i])
            }
            this.showspinner = false
            this.orderArray()
          }.bind(this),
          error: function (error) {
            this.$dispatch('error', JSON.stringify(error))
          }.bind(this)
        })
      }
    },
    fileInfo: function (file) {
      var jobject = {}
      jobject.name = file.name
      jobject.size = file.size
      jobject.src = ''
      return jobject
    },
    removeFile (e) {
      var data = this.files[e].URL
      $.ajax({
        type: 'POST',
        url: store.root + 'api/products/deletephoto',
        data: data,
        dataType: 'text',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.files.splice(e, 1)
          this.orderArray()
        }.bind(this),
        error: function (error) {
          this.$dispatch('error', JSON.stringify(error))
        }.bind(this)
      })
    }
  },
  computed: {
    filesLength: function () {
      return this.files.length < 5
    }
  }
}
</script>
<style scoped>
.upload-drop-zone {
  color: #ccc;
  border-style: dashed;
  border-color: #ccc;
  text-align: center;
  width: 100%;
  height: auto;
}
.upload-drop-zone span {
  color: #ccc;
  font-size: 5em;
  text-align: center;
}
.uploaded-zone {
  border-style: groove;
  border-color: #ccc;
  text-align: center;
  border-width: 2px;
}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
  border-color: #ccc;
}
</style>


// WEBPACK FOOTER //
// Upload.vue?249205b3